import axios from '@/axios'

export default {
	namespaced: true,

	state: {
		contracts: []
	},

	actions: {
		fetchAll({ commit }, { clientId, contractNo, date, isComplete, ownerIds, page, perPage, subContractNo, usePagination } = {}) {
			const params = { clientId, contractNo, date, isComplete, sortByCreatedAt: true, nonDeleted: true, page, perPage, subContractNo, usePagination };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				if (params[key] !== null && params[key] !== undefined) urlSearchParams.append(key, params[key])
			});
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/contract', {
				params: urlSearchParams
			})
		},
		fetchStatistics({ commit }, { clientId, contractNo, date, isComplete, ownerIds, page, perPage } = {}) {
			const params = { clientId, contractNo, date, isComplete, sortByCreatedAt: true, nonDeleted: true, page, perPage };
			const urlSearchParams = new URLSearchParams();
			Object.keys(params).forEach(key => {
				if (params[key]) urlSearchParams.append(key, params[key]);
			});
			if (Array.isArray(ownerIds)) {
				ownerIds.forEach(id => urlSearchParams.append('ownerIds', id));
			}
			return axios.get('/contract/SalesStatistics', {
				params: urlSearchParams
			}).then(({ data }) => {
				return {
					saleBalances: data.saleBalances,
					totalSales: data.totalSales, 
				};
			})
		},
		fetchById({ commit }, { id }) {
			return axios.get(`/contract/${id}`);
		},
		fetchByNo({ commit }, { no }) {
			return axios.get('/contract/contractNo', { params: { contractNo: no } });
		},

		fetchBySubNo({ commit }, { no }) {
			return axios.get('/contract/subContractNo', { params: { subContractNo: no } });
		},

		fetchContractMixes({ commit }, { contractMixId }) {
			return axios.get(`/contract/mixContract/${contractMixId}`)
		},

		create({ commit }, { contractNo, date, clientId, sale, items, deviationPercentage, ownerId, type }) {
			return axios.post('/contract', { contractNo, date, clientId, sale, items, deviationPercentage, ownerId, type });
		},

		update({ commit }, { id, contractNo, date, clientId, sale, items, deviationPercentage, ownerId, type }) {
			return axios.put(`/contract/${id}`, { contractNo, date, clientId, sale, items, deviationPercentage, ownerId, type });
		},

		changeStatus ({ commit }, { contractId, isCompleted }) {
			return axios.put(`contract/${contractId}/status`, {}, { params: { isCompleted } }).then((data) => {
				return data
			})
		},

		delete({ commit }, { id }) {
			return axios.delete(`/contract/${id}`);
		}
	},
}